
import { defineComponent, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import _ from "lodash";
import { ApiBase, ApiDebtor } from "@/core/api";
import { TaggingItem } from "@/core/directive/interface/common";
import { OCPSECommerceTaxPayablesTableFilter } from "@/core/directive/interface/finacialReport";
import { DebtorOption } from "@/core/directive/interface/debtor";

export default defineComponent({
  name: "transaction-report-finacial-report-ocps-e-commerce-tax-payables-dropdown",
  emits: ["submit-filter", "reset-filter"],
  setup(props, { emit }) {
    const { t } = useI18n();

    const formRef = ref<null | HTMLFormElement>(null);

    const formData = ref<OCPSECommerceTaxPayablesTableFilter>({
      creditor_entity_id: "",
      debtor_entity_id: "",
      transaction_date_start: "",
      transaction_date_end: "",
      custom3: "",
    });

    const options = ref({
      entityLoading: false,
      entityOptions: [] as DebtorOption[],
      custom3Options: [] as TaggingItem[],
    });

    const getEntityData = async (value) => {
      options.value.entityLoading = true;
      const { data } = await ApiDebtor.searchDebtor({
        value: value,
      });
      options.value.entityLoading = false;
      if (data.code == 0) {
        options.value.entityOptions = data.data;
      }
    };

    const debounceEntitySearch = _.debounce(getEntityData, 1000);

    const searchEntityItems = (query: string) => {
      debounceEntitySearch(query);
    };

    const getTaggingData = async () => {
      const { data } = await ApiBase.getTaggingData({
        short_key: ["ocps_order_type"],
      });
      if (data.code == 0) {
        options.value.custom3Options = data.data.ocps_order_type.items;
      }
    };

    const submit = () => {
      emit("submit-filter", formData.value);
    };

    const handleReset = () => {
      formRef.value?.resetFields();
      emit("reset-filter");
    };

    onMounted(() => {
      getTaggingData();
    });

    return {
      t,
      formData,
      formRef,
      options,
      searchEntityItems,
      submit,
      handleReset,
    };
  },
});
